import { addMessages, getLanguage, getLocale } from '../../i18n/i18nWrapper';
import localeStrings from '@tcc/web-translated-strings';

const language = getLanguage();
const locale = getLocale();

/**
 * Expose the global i18n values to the app props
 * @param {App} app
 * @return {Promise}
 */
export default function setup(app) {

  // Add english
  addMessages({ en: require('../../i18n/en') });

  // Try to add the user's locale
  if (locale !== 'en') {
    addMessages({ [locale]: localeStrings['auth-pages-react'][locale] });
  }

  // Try to add the user's language
  if (language !== 'en' && language !== locale) {
    addMessages({ [language]: localeStrings['auth-pages-react'][language] });
  }

  app.setProps({ locale, language });

  return Promise.resolve(true);
}
